import React, { Component } from "react"
import ReactApexChart from "react-apexcharts"

class LeadStatusChart extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      series: [15, 10, 25, 50],
      options: {
        labels: ["Cold", "undefined","Hot","Warm"],
        colors:['#2F5F98', '#6CE5E8','#41B8D5','#2D8BBA'],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          verticalAlign: "middle",
          floating: false,
          fontSize: "14px",
          offsetX: 0,
          offsetY: -10,
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                height: 240,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    }
  }
  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="pie"
          height="320"
          className="apex-charts"
        />
      </React.Fragment>
    )
  }
}

export default LeadStatusChart
